export default __webpack_public_path__ + "static/media/I_Iogurte.44bf99ad.mp3";